import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

//request:  {"packageName":"abc-gold","instrument":"523-FUNDS_TRANSFER_CREDIT,524-FUNDS_TRANSFER_DEBIT"}
const getRequestBody = (data: any) => {
  return {
    instrument: data?.instrument,
    packageName: data?.packageName,
  }
}

const responseParser = (response: any) => {
  return isSuccessResponse(response)
}

const addPackageToInstrument = (data: any, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.routingPack2InstCreate),
    method: 'POST',
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      ...getRequestBody(data),
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { addPackageToInstrument }
